<template>
  <v-container id="timesheets" fluid tag="section">
    <react-wrapper :component="TimesheetUtilisationSummaryComponent" />
  </v-container>
</template>

<script>
  import Vue from 'vue'
  import { TimesheetUtilisationSummary } from '../../react-migration/src/pages/TimesheetUtilisationSummary'

  export default Vue.extend({
    name: 'IdcPageTimesheetsSummary',
    props: {
      canRead: {
        type: Boolean,
        default: () => true,
      },
      canCreate: {
        type: Boolean,
        default: () => true,
      },
      canEdit: {
        type: Boolean,
        default: () => true,
      },
      canDelete: {
        type: Boolean,
        default: () => true,
      },
    },
    computed: {
      TimesheetUtilisationSummaryComponent() {
        return TimesheetUtilisationSummary
      },
    },
  })
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  h3 {
    margin: 40px 0 0;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }
  a {
    color: #42b983;
  }
</style>
